import { render, staticRenderFns } from "./GroupPublisherSelection.vue?vue&type=template&id=0e0c5a3c&scoped=true&"
import script from "./GroupPublisherSelection.vue?vue&type=script&lang=js&"
export * from "./GroupPublisherSelection.vue?vue&type=script&lang=js&"
import style0 from "./GroupPublisherSelection.vue?vue&type=style&index=0&id=0e0c5a3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0c5a3c",
  null
  
)

export default component.exports